import { render, staticRenderFns } from "./m-section-header.vue?vue&type=template&id=7e51ca7c"
import script from "./m-section-header.vue?vue&type=script&lang=js"
export * from "./m-section-header.vue?vue&type=script&lang=js"
import style0 from "./m-section-header.vue?vue&type=style&index=0&id=7e51ca7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports